import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@atredux/store'
import { useFeatureFlag } from '@services/featureFlags'
import { VIEW_ONLY_TOOLS_FLAG } from '@services/ToolMenuConfigService'

/**
 * useSelector for a selector that depends on the view-only decision (isViewOnlySupportedTool).
 *
 * VIEW_ONLY_TOOLS_FLAG lives in the feature-flag cache, not Redux, and react-redux reuses a
 * selector's last result while the store state and selector are unchanged. Keying the selector
 * on the flag value makes it recompute when the flag loads or flips.
 */
export function useViewOnlySelector<T> (selector: (state: RootState) => T): T {
    const { enabled } = useFeatureFlag(VIEW_ONLY_TOOLS_FLAG)
    const keyedSelector = useCallback((state: RootState) => selector(state), [selector, enabled])
    return useSelector(keyedSelector)
}
